<template>
	<div class="dropleft grid-settings" ref="gridSettings">
		<button class="border-0 bg-transparent menu-btn p-1" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ref="gridSettingsButton">
			<i class="fas fa-cog " id="agGridSettingIcon"></i>
		</button>
		<ul class="dropdown-menu multi-level  py-0" style="position: relative !important;" role="menu" aria-labelledby="dropdownMenu" ref="dropdown">
			<li v-if="localOptions?.buttons" class="p-0 " ref="li_buttons" v-for="(button, ind) in localOptions.buttons" :key="button.id">
				<a :class="[{ [button.class]: true }, { 'd-none': !button.visible }]" @click="() => { button.handler() }" style="cursor: pointer" class="dropdown-item pr-2 pl-5">
					<icon :name="typeof button.options.icon === 'function' ? button.options.icon() : button.options.icon" :key="button.options.icon === 'function' && button.options.icon()" />
					<span class="mr-3">{{ typeof button.options.title === 'function' ? button.options.title() : button.options.title }}</span>
				</a>
			</li>
		</ul>

	</div>
</template>
<script>
	import ColumnsVisibility from '../columns-visibility'
	import GridExporter from '../grid-exporter.vue'
	import $ from 'jquery'
	import Icon from '../../general/icon.vue'
	import { i18nInstance } from '@/plugins/localization'
	import $sc from '@/plugins/shortcut.collection'
	import Nk_anime from '@/plugins/anime'
	import { mapActions } from 'vuex'
	import _ from 'lodash'

	export default {
		name: 'GridSettings',

		// Props
		props: {
			filteredColumns: {
				type: Array,
				default() {
					return []
				},
			},

			filteredData: {
				type: Array,
				default() {
					return []
				},
			},

			stateUID: {
				type: String,
				default: '',
			},

			filterRowChecked: {
				type: Boolean,
				default: true,
			},

			aggregateRowChecked: {
				type: Boolean,
				default: true,
			},
			buttons: {
				type: Array,
				default: [],
			},
			permissions: {
				type: Object
			},
			options: Object,
		},

		emits: ['change-visibility', 'templates-button-clicked', 'filter-row-visibility', 'aggregate-row-visibility'],
		created() {
			this.localOptions = _.merge(this.localOptions, this.options)
			this.params?.options && (this.localOptions = _.merge(this.localOptions, this.params.options))
		},
		// Mounted
		mounted() {
			$(document).on('click', '.filter-row-visibility-li', (e) => {
				e.stopPropagation()
			})

			$(this.$refs.gridSettings).on('show.bs.dropdown', (e) => {
				$(this.$refs.dropdown).prependTo($(e.target).closest('.grid-mainbar'))
			})
		},

		// Before unmount
		beforeUnmount() {
			$(document).off('click', '.filter-row-visibility-li')
			$(this.$refs.gridSettings).off('show.bs.dropdown')
		},
		data() {
			return {
				localOptions: null,
			}
		},
		// Components
		components: {
			ColumnsVisibility,
			GridExporter,
			Icon,
		},
		watch: {
			options: {
				deep: true,
				handler() {
					this.localOptions = _.merge(this.localOptions, this.options)

				}
			}
		},
		// Methods
		methods: {

			changeVisibility(column) {
				this.$emit('change-visibility', column)
			},

			templatesButtonClicked() {
				this.$emit('templates-button-clicked')
			},

			filterRowVisibility() {
				this.$emit('filter-row-visibility')
			},

			aggregateRowVisibility() {
				this.$emit('aggregate-row-visibility', !this.aggregateRowChecked)
			},

		},
	}
</script>
